import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AlertComponent, MbsPopupType } from 'mbs-ui-kit';
import { getInvalidDiffTime, getSecondsFromDate } from 'mbs-ui-shared@utils';

@Component({
  selector: 'mbs-incorrect-time-alert',
  templateUrl: './incorrect-time-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, AlertComponent]
})
export class IncorrectTimeAlertComponent implements OnInit {
  @Input() expiredDate: string | Date;

  public timeToExpire: number;

  protected readonly getInvalidDiffTime = getInvalidDiffTime;
  public readonly alertType = MbsPopupType;

  ngOnInit() {
    this.timeToExpire = getSecondsFromDate(this.expiredDate);
  }
}
